import React, { useState, useCallback } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Input from '@ntuctech/devex-tangram/Input'
import { requiredValidation } from '../../../lib/formValidation'
import { Formik } from 'formik'
import { object as YupObject } from 'yup'
import ButtonContained from '@ntuctech/devex-tangram/Button/ButtonContained'
import {
  FormAction,
  FormContentWrapper,
} from '../../AccountsCommon/FormContent'
import SvgAlert from '@ntuctech/devex-tangram/Icon/SvgAlert'
import {
  VERIFY_EMAIL,
  REQUEST_CANCELLED,
  REQUEST_EXPIRED,
  INVALID_EMAIL,
} from '../../../utils/constants/payments'

const AddGovAgencyBox = styled.div``
const CancelRequestError = styled.div`
  margin-bottom: 0.75rem;
  display: flex;
  background: #fee7ed;
  font-size: 1rem;
  padding: 1rem;
  text-align: center;
`
const RequestCancelledMessage = styled.div`
  padding: 0.25rem;
`

function validateEmail(email) {
  //check that the input string is an well formed email
  if (!isValidEmail(email)) {
    return false
  }
  //check that the input email is in the whitelist
  var s,
    domainWhitelist = ['.gov.sg', '.edu.sg', 'sentosa.com.sg']
  for (s of domainWhitelist) {
    if (email.toLowerCase().endsWith(s)) {
      return true
    }
  }
  return false
}

const isValidEmail = email =>
  // eslint-disable-next-line no-useless-escape
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
    email
  )

const FormContent = formContentProps => {
  const {
    values,
    submitForm,
    handleChange,
    errors,
    touched,
    toggleErrorMessage,
    requestCancelled,
    requestExpired,
    invalidEmailMessage,
  } = formContentProps
  const { govAgencyEmail } = values
  const showErrorFor = inputName =>
    touched[inputName] && Boolean(errors[inputName])
  const showEmailError = showErrorFor('govAgencyEmail')
  return (
    <>
      <FormContentWrapper>
        {toggleErrorMessage && requestCancelled && !invalidEmailMessage && (
          <CancelRequestError>
            <SvgAlert size="m" color="#FF0000" />
            <RequestCancelledMessage>
              {' '}
              {REQUEST_CANCELLED}
            </RequestCancelledMessage>
          </CancelRequestError>
        )}
        {toggleErrorMessage && requestExpired && !invalidEmailMessage && (
          <CancelRequestError>
            <SvgAlert size="m" color="#FF0000" />
            <RequestCancelledMessage>
              {' '}
              {REQUEST_EXPIRED}
            </RequestCancelledMessage>
          </CancelRequestError>
        )}
        {invalidEmailMessage && (
          <CancelRequestError>
            <SvgAlert size="m" color="#FF0000" />
            <RequestCancelledMessage> {INVALID_EMAIL} </RequestCancelledMessage>
          </CancelRequestError>
        )}
        <Input
          data-testid="govAgencyEmail"
          type="text"
          name="govAgencyEmail"
          label="Government agency email"
          onChange={handleChange}
          required
          fullWidth
          value={govAgencyEmail}
          error={showEmailError}
        />
      </FormContentWrapper>
      <FormAction className="fpOnAccount__biz-form--action">
        <ButtonContained
          compact
          data-testid="EditBusinessProfileCta"
          className="EditBusinessProfileCta"
          onClick={submitForm}
        >
          {VERIFY_EMAIL}
        </ButtonContained>
      </FormAction>
    </>
  )
}

FormContent.propTypes = {
  values: PropTypes.object.isRequired,
  submitForm: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
  touched: PropTypes.object.isRequired,
  toggleErrorMessage: PropTypes.bool,
  requestCancelled: PropTypes.bool,
  requestExpired: PropTypes.bool,
  invalidEmailMessage: PropTypes.bool,
}

const AddGovernmentAgency = props => {
  const { onVerifyEmail, initialFormData } = props
  const [invalidEmailMessage, setInvalidEmailMessage] = useState(false)

  const onSubmit = useCallback(
    values => {
      const formData = { ...values }
      if (validateEmail(formData.govAgencyEmail)) {
        onVerifyEmail(formData.govAgencyEmail)
        setInvalidEmailMessage(false)
      } else {
        setInvalidEmailMessage(true)
      }
    },
    [onVerifyEmail, validateEmail]
  )
  const AddGovAgencySchema = YupObject().shape({
    govAgencyEmail: requiredValidation('nonempty@gmail.com', 'sdwwwwwe'),
  })
  return (
    <AddGovAgencyBox>
      <Formik
        initialValues={initialFormData}
        validationSchema={AddGovAgencySchema}
        onSubmit={onSubmit}
      >
        {formikProps => (
          <FormContent
            invalidEmailMessage={invalidEmailMessage}
            {...formikProps}
            {...props}
          />
        )}
      </Formik>
    </AddGovAgencyBox>
  )
}

AddGovernmentAgency.propTypes = {
  onVerifyEmail: PropTypes.func.isRequired,
  initialFormData: PropTypes.object.isRequired,
}

export default AddGovernmentAgency
